import React from "react";
import {Link} from "react-router-dom";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from "react-bootstrap/Container";
import {Outlet} from "react-router";


function Panel() {
    return (
        <div className="panel_page_container">
            <Navbar bg="light" expand="lg">
                <Container fluid>
                    <Navbar.Brand>Admin Panel</Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            <Nav.Link as={Link} to="/admin/panel">Dashboard</Nav.Link>
                            <NavDropdown title="HomePage" id="navbarScrollingDropdown">
                                <NavDropdown.Item as={Link} to="/admin/panel/menu">Menu</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/admin/panel/slideshow">Slide Show</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/admin/panel/banner">Banner</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link as={Link} to="/admin/panel/page-items">Pages</Nav.Link>
                            <NavDropdown disabled title="Curtains" id="navbarScrollingDropdown">
                                <NavDropdown.Item as={Link} to="/admin/panel/models">Models</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link disabled>Products</Nav.Link>
                        </Nav>
                        <Link className="margin_side_1rem" to="/en">Back To Website</Link>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Outlet/>
        </div>
    );
}
export default Panel;